import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { AlertTriangle, HelpCircle } from "lucide-react";

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "primary",
  onConfirm,
  onCancel,
}) => {
  const isDanger = variant === "danger";

  return (
    <Dialog
      open={!!open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        className: "!rounded-xl !shadow-lg",
      }}
    >
      <DialogContent className="!px-5 !pt-5 !pb-4">
        <div className="flex items-start gap-3.5">
          {/* Icon */}
          <div
            className={`
              flex h-9 w-9 shrink-0 items-center justify-center rounded-lg
              ${
                isDanger
                  ? "bg-red-50 text-red-600"
                  : "bg-primary-50 text-primary-600"
              }
            `}
          >
            {isDanger ? (
              <AlertTriangle size={18} strokeWidth={2} />
            ) : (
              <HelpCircle size={18} strokeWidth={2} />
            )}
          </div>

          {/* Content */}
          <div className="min-w-0 pt-0.5">
            <h2 className="text-[14px] font-semibold text-gray-900">
              {title}
            </h2>

            {message && (
              <p className="mt-1.5 text-[13px] leading-5 text-gray-500">
                {message}
              </p>
            )}
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className="
          !border-t !border-gray-100
          !px-5 !py-3
          !gap-1
        "
      >
        <Button
          type="button"
          onClick={onCancel}
          className="
            !h-8
            !rounded-lg
            !px-3
            !text-[12px]
            !font-semibold
            !normal-case
            !text-gray-500
            hover:!bg-gray-50
            hover:!text-gray-700
          "
        >
          {cancelLabel}
        </Button>

        <Button
          type="button"
          variant="contained"
          onClick={onConfirm}
          className={`
            !h-8
            !rounded-lg
            !px-3.5
            !text-[12px]
            !font-semibold
            !normal-case
            !shadow-none
            ${
              isDanger
                ? "!bg-red-600 hover:!bg-red-700"
                : "!bg-primary-600 hover:!bg-primary-700"
            }
          `}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
